import React, { useEffect, useState } from "react";
import "./Products.css";
import HeadingSection from "../Campaign/HeadingSection/HeadingSection";
import CreateCampaignBtn from "../Campaign/CreateCampaignBtn/CreateCampaignBtn";
import SearchBar from "../Campaign/SearchBar/SearchBar";
import { useDispatch, useSelector } from "react-redux";
import { productsActions } from "../../store/products-slice";
import { useNavigate } from "react-router-dom";
import UNIVERSAL from "../../config/config";
import ProductCard from "../ProductCard/ProductCard";
import filterIcon from "../../assets/icons/Tuning.svg";
import { toast } from "react-toastify";
import NoProductsImg from "../../assets/images/no-products.svg";
import EditIcon from "../../assets/icons/EditIcon.svg"
import DeleteIcon from "../../assets/icons/DeleteIcon.svg"

const Products = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [productsData, setProductsData] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user.user);

  async function getProducts() {
    return fetch(UNIVERSAL.BASEURL_1 + "/product/listProduct", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
      },
      body: JSON.stringify({
        businessId: user?.app_business_id,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.data) {
          setProductsData(responseJson.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    getProducts();
  }, []);

  function handleProductEdit(productId) {
    const data = [...productsData];
    const findproduct = data.find((data) => {
      return data.product_id === productId;
    });
    dispatch(productsActions.setEditProductDetails(findproduct));
    navigate("/products/update-product");
  }

  async function handleProductDelete(productId) {
    return fetch(UNIVERSAL.BASEURL_1 + "/product/removeProduct", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
      },
      body: JSON.stringify({
        productId: productId.toString(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        toast(response?.message, { type: "info" });
        getProducts();
      })
      .catch((error) => {
        console.log(error.message);
        toast("Unable to delete product. Something went wrong, please try again.", { type: "error" });
      });
  }
  console.log(productsData, "PRODUCT DATA")

  return (
    <div id="campaign">
      {!productsData?.length && 
        <div className='noCampaign'>
          <img src={NoProductsImg} />
          <h2>No products</h2>
          <CreateCampaignBtn  url='/products/add-new-product' text="Create new product" />
        </div>
      }
      {productsData && productsData?.length !==0 && (
        <>
          <HeadingSection heading="My Products" />
          <div className="products-c-section">
            <SearchBar className="searchBar" searchTerm={searchTerm} setSearchTerm={setSearchTerm} placeholder="Search for the product" icon={filterIcon} />
            <CreateCampaignBtn url="/products/add-new-product" text="Add new product" />
          </div>
          <div className="productCards">
            {productsData &&
              productsData
                .filter((data) => {
                  if (searchTerm == "") {
                    return data;
                  } else if (data.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                    return data;
                  }
                })
                .map((data, index) => {
                  return (
                    <ProductCard
                      key={index}
                      img={data?.media[0]?.url ? data?.media[0]?.url : "https://zocket-image-library-output2.s3.amazonaws.com/marketing/Group%2048097025.png"}
                      title={data?.name.length > 15 ? data.name.slice(0, 15) + "..." : data.name}
                      price={data.currency + " . " + data.selling_price.toLocaleString()}
                      body={data.description.length > 85 ? data.description.slice(0, 84).replace(/(<([^>]+)>)/gi, "") + "..." : data.description.replace(/(<([^>]+)>)/gi, "")}
                      editIcon={EditIcon}
                      deleteIcon={DeleteIcon}
                      handleProductEdit={handleProductEdit}
                      data={data}
                      handleProductDelete={handleProductDelete}
                    />
                  );
                })}
          </div>
        </>
      )}
    </div>
  );
};

export default Products;
